/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Start_CameraInputs */

const th_video_start_camera = /** @type {(inputs: Video_Start_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เปิดกล้อง`)
};

const en_video_start_camera = /** @type {(inputs: Video_Start_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start camera`)
};

const ja_video_start_camera = /** @type {(inputs: Video_Start_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カメラを開始`)
};

const zh_video_start_camera = /** @type {(inputs: Video_Start_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`启动摄像头`)
};

const es_video_start_camera = /** @type {(inputs: Video_Start_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar cámara`)
};

const pt_video_start_camera = /** @type {(inputs: Video_Start_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar câmera`)
};

const id_video_start_camera = /** @type {(inputs: Video_Start_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulai kamera`)
};

const fr_video_start_camera = /** @type {(inputs: Video_Start_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Démarrer la caméra`)
};

const tl_video_start_camera = /** @type {(inputs: Video_Start_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simulan ang camera`)
};

const vi_video_start_camera = /** @type {(inputs: Video_Start_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bật máy ảnh`)
};

const ko_video_start_camera = /** @type {(inputs: Video_Start_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`카메라 시작`)
};

const de_video_start_camera = /** @type {(inputs: Video_Start_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamera starten`)
};

const ru_video_start_camera = /** @type {(inputs: Video_Start_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Включить камеру`)
};

const tr_video_start_camera = /** @type {(inputs: Video_Start_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamerayı başlat`)
};

const it_video_start_camera = /** @type {(inputs: Video_Start_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avvia la fotocamera`)
};

const pl_video_start_camera = /** @type {(inputs: Video_Start_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Włącz kamerę`)
};

const uk_video_start_camera = /** @type {(inputs: Video_Start_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Увімкнути камеру`)
};

const hi_video_start_camera = /** @type {(inputs: Video_Start_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कैमरा शुरू करें`)
};

const ar_video_start_camera = /** @type {(inputs: Video_Start_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تشغيل الكاميرا`)
};

const ms_video_start_camera = /** @type {(inputs: Video_Start_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulakan kamera`)
};

const bn_video_start_camera = /** @type {(inputs: Video_Start_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ক্যামেরা চালু করুন`)
};

const zh_tw2_video_start_camera = /** @type {(inputs: Video_Start_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`啟動相機`)
};

const zh_hk2_video_start_camera = /** @type {(inputs: Video_Start_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`啟動相機`)
};

const ur_video_start_camera = /** @type {(inputs: Video_Start_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کیمرا چالو کریں`)
};

const fa_video_start_camera = /** @type {(inputs: Video_Start_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`روشن کردن دوربین`)
};

const sw_video_start_camera = /** @type {(inputs: Video_Start_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Washa kamera`)
};

const nl_video_start_camera = /** @type {(inputs: Video_Start_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camera starten`)
};

/**
* | output |
* | --- |
* | "Start camera" |
*
* @param {Video_Start_CameraInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const video_start_camera = /** @type {((inputs?: Video_Start_CameraInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Start_CameraInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_video_start_camera(inputs)
	if (locale === "ja") return ja_video_start_camera(inputs)
	if (locale === "zh") return zh_video_start_camera(inputs)
	if (locale === "es") return es_video_start_camera(inputs)
	if (locale === "pt") return pt_video_start_camera(inputs)
	if (locale === "id") return id_video_start_camera(inputs)
	if (locale === "fr") return fr_video_start_camera(inputs)
	if (locale === "tl") return tl_video_start_camera(inputs)
	if (locale === "vi") return vi_video_start_camera(inputs)
	if (locale === "ko") return ko_video_start_camera(inputs)
	if (locale === "de") return de_video_start_camera(inputs)
	if (locale === "ru") return ru_video_start_camera(inputs)
	if (locale === "tr") return tr_video_start_camera(inputs)
	if (locale === "it") return it_video_start_camera(inputs)
	if (locale === "pl") return pl_video_start_camera(inputs)
	if (locale === "uk") return uk_video_start_camera(inputs)
	if (locale === "hi") return hi_video_start_camera(inputs)
	if (locale === "ar") return ar_video_start_camera(inputs)
	if (locale === "ms") return ms_video_start_camera(inputs)
	if (locale === "bn") return bn_video_start_camera(inputs)
	if (locale === "zh-TW") return zh_tw2_video_start_camera(inputs)
	if (locale === "zh-HK") return zh_hk2_video_start_camera(inputs)
	if (locale === "ur") return ur_video_start_camera(inputs)
	if (locale === "fa") return fa_video_start_camera(inputs)
	if (locale === "sw") return sw_video_start_camera(inputs)
	if (locale === "nl") return nl_video_start_camera(inputs)
	return en_video_start_camera(inputs)
});